<template>
  <div class="absolute w-full h-full top-0 left-0 bg-black-transparent flex items-center z-50">
    <div
      class="popup w-6/10 1.5xl:w-5/10 fhd:w-4/10 mx-auto bg-white flex flex-col justify-evenly items-center classen__rounded relative">
      <p class="title">{{ getTranslation('scanQrTitle') }}</p>
      <c-loader v-if="!isLoaded" :inline="true" :bg-blur="false"/>
      <canvas :class="{'hidden': !isLoaded}" id="qr-canvas"></canvas>
      <div class="container">
        <button @click="stop"
                class="classen__button flex items-center justify-center justify-self-center mb-5">
          <p class="m-0">{{ getTranslation('cancel') }}</p>
        </button>

        <div class="camera-div cursor-pointer" @click="swapCamera" v-if="showToggleCamera"><img
          src="../../assets/icons/camera-reverse.svg"/></div>
      </div>
    </div>
  </div>
</template>

<script>
import getTranslation from "../../mixins/getTranslation";
import qrReader from "../../mixins/qrReader";
import Loader from "../Loader";
import Button from "../Button";

export default {
  name: "QrReaderPopup",

  mixins: [getTranslation, qrReader],

  components: {
    Button,
    'c-loader': Loader,
  },

  props: {},

  data() {
    return {
      isLoaded: false,
    }
  },

  created() {

  },

  mounted() {
    this.startQr();
  },

  destroyed() {
    this.stop();
  },

  computed: {},

  watch: {},

  methods: {}
}
</script>

<style scoped>
#qr-canvas {
  width: 90%;
  max-width: 536px;
  @apply m-6
}

.camera-div {
  height: 42px;
  width: 42px;
  border-radius: 25px;
  position: absolute;
  right: 0;
  @apply bg-classen__primary flex justify-center items-center
}

.container {
  max-width: 536px;
  width: 90%;
  position: relative;
  display: flex;
  justify-content: center;
}

.title {
  color: #707070;
  @apply mt-4
}
</style>
